<div class="flex flex-col flex-1 min-h-0 w-full">
  @if (!id()) {
    <!-- Show title only on legacy modals that use the observable -->
    <h2 class="text-xl font-semibold mt-1 pb-1 w-full shrink-0">
      {{ '#WWS_CORE.COMMANDS.ARTIKELINFO.NAME' | translate }}
    </h2>
  }

  <div class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
    <div>
      <ng-container *ngComponentOutlet="modalComponent; inputs: inputs()"></ng-container>
    </div>
  </div>
</div>
